function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M5.97.083C3.78.083 2 1.884 2 4.09c0 .711.187 1.378.51 1.957l.003.012.021.045.004.003 3.135 5.479a.364.364 0 00.635-.004l3.098-5.495c.002-.001.004-.002.004-.004a.293.293 0 00.029-.065A4 4 0 009.94 4.09c0-2.182-1.743-3.96-3.9-3.999-.005 0-.009-.004-.013-.004L5.99.083h-.02zm0 1.578c1.26 0 2.29 1.042 2.29 2.315S7.23 6.287 5.97 6.287 3.68 5.25 3.68 3.976s1.03-2.315 2.29-2.315z",
  fill: "#F58220",
  fillRule: "evenodd"
});

function SvgPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12
  }, props), _ref);
}

export default SvgPin;